var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 671.574,
    height: 229,
    viewBox: "0 0 671.574 229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-700.426 -1086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "firefly-svgrepo-com",
    transform: "matrix(0.755, 0.656, -0.656, 0.755, 786.487, 1073.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M176.785,94.041c-5.965-14.4-18.182-28.129-34.4-38.656A112.94,112.94,0,0,0,128.934,47.9c0-.058,0-.117,0-.175a29.957,29.957,0,0,0-18.022-27.445l10.165-10.165A5.923,5.923,0,0,0,112.7,1.736L99.089,15.35,85.609,1.87a5.923,5.923,0,0,0-8.377,8.377l9.986,9.986A29.963,29.963,0,0,0,69.1,47.722c0,.058,0,.117,0,.176a112.965,112.965,0,0,0-13.45,7.488c-16.22,10.527-28.438,24.256-34.4,38.655a30.022,30.022,0,0,0,41.075,38.391,43.015,43.015,0,0,0,73.382,0,30.028,30.028,0,0,0,41.076-38.392ZM99.018,29.65a18.105,18.105,0,0,1,17.476,13.467,46.27,46.27,0,0,0-12.653-2.1H94.193a46.265,46.265,0,0,0-12.652,2.1A18.106,18.106,0,0,1,99.018,29.65Zm16.994,74.432H82.024L99.019,62.574ZM48.978,123.713A18.189,18.189,0,0,1,32.2,98.576C40.143,79.39,60.649,64.293,77.244,57.231a5.884,5.884,0,0,0,.779-.321,57.209,57.209,0,0,1,12.011-3.658L67.748,107.685c-.006.014-.013.028-.017.043l-1.949,4.76a18.181,18.181,0,0,1-4.817,6.72c-.08.062-.156.128-.231.193a18.142,18.142,0,0,1-11.755,4.311Zm50.04,17.437A31,31,0,0,1,71.76,125.089,30.194,30.194,0,0,0,76.735,117l.438-1.07h43.689l.447,1.093a30.107,30.107,0,0,0,4.965,8.07A31,31,0,0,1,99.018,141.15ZM156,122.323a18.146,18.146,0,0,1-18.746-2.956c-.054-.046-.107-.092-.163-.136a18.116,18.116,0,0,1-4.831-6.721l-1.956-4.778-.021-.052L108,53.244a57.1,57.1,0,0,1,12.041,3.669,5.793,5.793,0,0,0,.714.295c16.591,7.054,37.131,22.162,45.086,41.368A18.2,18.2,0,0,1,156,122.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M172.717,183.3a5.923,5.923,0,0,0-8.377,8.377l13.1,13.1a5.924,5.924,0,0,0,8.378-8.377Z",
    transform: "translate(-30.192 -38.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M118.747,202.182a5.923,5.923,0,0,0-5.924,5.924v18.532a5.924,5.924,0,0,0,11.847,0V208.106A5.923,5.923,0,0,0,118.747,202.182Z",
    transform: "translate(-19.728 -42.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M61.29,183.3l-13.1,13.1a5.924,5.924,0,0,0,8.378,8.377l13.1-13.1A5.924,5.924,0,0,0,61.29,183.3Z",
    transform: "translate(-5.777 -38.163)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PASSING_PARCEL",
    "data-name": "PASSINGPARCEL",
    transform: "translate(922 1213)",
    fontSize: 107,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PASSING"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 83
  }), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 83
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 81
  }, "PARCEL"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.676cd2ec4a89f9eec82b258a9413fd74.svg";
export { ForwardRef as ReactComponent };